import React from 'react';

const IconCashbackOutstanding = () => (
  <svg
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.25 8.74957V6.99957H1.75C0.78575 6.99957 0 7.78532 0 8.74957V12.2496H12.6193C12.376 11.1803 12.25 10.0288 12.25 8.74957Z'
      fill='#17C981'
    />
    <path
      d='M27.9282 15.7496C26.7347 17.5888 24.9147 19.1533 22.3072 20.6513C21.9065 20.8806 21.455 20.9996 21 20.9996C20.545 20.9996 20.0935 20.8806 19.698 20.6548C17.0905 19.1533 15.2705 17.5871 14.0753 15.7496H0V24.4996C0 25.4656 0.78575 26.2496 1.75 26.2496H26.25C27.216 26.2496 28 25.4656 28 24.4996V15.7496H27.9282ZM7.875 20.9996H4.375C3.892 20.9996 3.5 20.6076 3.5 20.1246C3.5 19.6416 3.892 19.2496 4.375 19.2496H7.875C8.358 19.2496 8.75 19.6416 8.75 20.1246C8.75 20.6076 8.358 20.9996 7.875 20.9996Z'
      fill='#17C981'
    />
    <path
      d='M27.4697 4.4463L21.3447 1.8213C21.1225 1.7268 20.8758 1.7268 20.6535 1.8213L14.5285 4.4463C14.2083 4.5828 14 4.89955 14 5.24955V8.74955C14 13.5638 15.7798 16.3778 20.5643 19.1341C20.699 19.2111 20.8495 19.2496 21 19.2496C21.1505 19.2496 21.301 19.2111 21.4357 19.1341C26.2202 16.3848 28 13.5708 28 8.74955V5.24955C28 4.89955 27.7917 4.5828 27.4697 4.4463ZM24.3092 8.4223L20.8092 12.7973C20.6412 13.0038 20.3892 13.1246 20.125 13.1246C20.1128 13.1246 20.0988 13.1246 20.0883 13.1246C19.81 13.1123 19.5527 12.9688 19.397 12.7361L17.647 10.1111C17.3792 9.70855 17.4877 9.16605 17.8902 8.8983C18.2892 8.6323 18.8335 8.7373 19.103 9.14155L20.1897 10.7708L22.9408 7.3303C23.2435 6.95405 23.7948 6.89455 24.171 7.1938C24.549 7.49305 24.6085 8.0443 24.3092 8.4223Z'
      fill='#FCA600'
    />
  </svg>
);

export default IconCashbackOutstanding;
